import { render, staticRenderFns } from "./local-config.vue?vue&type=template&id=36a101d4"
import script from "./local-config.vue?vue&type=script&lang=js"
export * from "./local-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports